<template>
  <a-modal
    :title="title === '1' ? $t('add') : $t('edit')"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('close')"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'relationName')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'relationName')" v-decorator="[ 'name', validatorRules.name]" :disabled='title === "2"'/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'relationKey1')">
          <a-select v-decorator="[ 'key1', validatorRules.key1]" :placeholder="$t('select') + ' ' + $t(I18N_KEY + 'relationKey1')">
            <a-select-option v-for='item in types' :key='item.value'>
              {{item[fieldName] + "(" + item['value'] + ")"}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'relationKey2')">
          <a-select v-decorator="[ 'key2', validatorRules.key2]" :placeholder="$t('select') + ' ' + $t(I18N_KEY + 'relationKey2')">
            <a-select-option v-for='item in types' :key='item.value'>
<!--              {{item[fieldName]}}-->
              {{item[fieldName] + "(" + item['value'] + ")"}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'relationRate1')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'relationRate1')" v-decorator="[ 'rate1', validatorRules.rate1]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'relationRate2')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'relationRate2')" v-decorator="[ 'rate2', validatorRules.rate2]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'relationType')">
          <a-select v-decorator="[ 'relation', validatorRules.relation]" :placeholder="$t('select') + ' ' + $t(I18N_KEY + 'relationType')">
            <a-select-option v-for='item in relationTypes' :key='item.value'>
              {{item[fieldName]}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'relationStatus')">
          <a-radio-group
            v-decorator="['status', validatorRules.status]">
            <span v-for="item in commonStatuses">
              <a-radio :value=item.value>{{ item[fieldName] }}</a-radio>
            </span>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
const I18N_KEY = 'teleMarket.';
export default {
  name: "SeatModal",
  props: {
    types: {
      type: Array,
      default: () => [],
    },
    commonStatuses: {
      type: Array,
      default: () => [],
    },
    relationTypes: {
      type: Array,
      default: () => [],
    },
    fieldName: {
      type: String,
      default: () => 'textCn',
    }
  },
  data () {
    return {
      I18N_KEY,
      title:"Action",
      visible: false,
      disabled: true,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules:{
        name:{
          rules: [
            { required: true, message: 'Please input name!' },
          ]},
        key1:{
          rules: [
            { required: true, message: 'Please select key1!' },
          ]},
        key2:{
          rules: [
            { required: true, message: 'Please select key2!' },
          ]},
        rate1:{
          rules: [
            { required: true, message: 'Please input rate1!' },
          ]},
        rate2:{
          rules: [
            { required: true, message: 'Please input rate2!' },
          ]},
        relation:{
          rules: [
            { required: true, message: 'Please input relation!'},
          ]},
        status:{
          rules: [
            { required: true, message: 'Please select status!' },
          ]},
      },
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({});
    },
    edit (record) {
      this.form.resetFields();
      this.open();
      this.model = Object.assign({}, record)
      this.model = {
        ...this.model,
        status: this.model.status != undefined ? '' + this.model.status : '1',
      }

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'name', 'key1', 'key2', 'rate1','rate2','relation','status'))
      });

    },
    open () {
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    openLoading () {
      this.confirmLoading = true;
    },
    closeLoading () {
      this.confirmLoading = false;
    },
    handleOk () {
      // console.log(88888)
      const that = this;
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = {
            ...values,
          }
          this.$emit('ok', formData);

        }
      })
    },
    handleCancel () {
      this.close()
    },
  }
}
</script>

<style scoped>

</style>